// CAVIET: DO NOT EDIT!
// This file is automatically generated by the script. It will be overwritten.
const awsconfig = {
  Auth: {
    identityPoolId: '',
    region: 'ap-northeast-1',
    userPoolId: 'ap-northeast-1_12DmtnvGO',
    userPoolWebClientId: '3rdna03idudfmvbmb3qso73srb'
  },
  API: {
    endpoints: [
      {
        name: 'dev',
        endpoint: 'https://ahixxzzr99.execute-api.ap-northeast-1.amazonaws.com/dev'
      }
    ]
  }
};

export default awsconfig;
